<script lang="ts" setup>

useSeoMeta({
  title: "Datenschutz",
  ogTitle: "Datenschutz"
})
</script>
<template>
  <PublicPageIntro eyebrow="Rechtliches" title="Datenschutz" compact />
  <PublicLegalContent>
    <p>
      Wir legen großen Wert auf den Schutz Ihrer Daten. Um Sie in vollem Umfang über die Verwendung personenbezogener
      Daten zu informieren, bitten wir Sie die folgenden Datenschutzhinweise zur Kenntnis zu nehmen.
    </p>
    
    <h2>Persönliche Daten</h2>
    <p>
      Persönliche Daten, die Sie auf dieser Website elektronisch übermitteln, wie zum Beispiel Name, E-Mail-Adresse,
      Adresse oder andere persönlichen Angaben, werden von uns nur zum jeweils angegebenen Zweck verwendet, sicher
      verwahrt und nicht an Dritte weitergegeben. Der Provider erhebt und speichert automatisch Informationen am
      Webserver wie verwendeter Browser, Betriebssystem, Verweisseite, IP-Adresse, Uhrzeit des Zugriffs usw. Diese Daten
      können ohne Prüfung weiterer Datenquellen keinen bestimmten Personen zugeordnet werden und wir werten diese Daten
      auch nicht weiter aus solange keine rechtswidrige Nutzung unserer Webseite vorliegt.
    </p>
    
    <h2>Datenschutzerklärung für Google Analytics</h2>
    <p>
      Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. („Google“). Google Analytics
      verwendet sog. „Cookies“, Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der
      Benutzung der Website durch Sie ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre Benutzung
      dieser Website werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert. Im Falle
      der Aktivierung der IP-Anonymisierung auf dieser Webseite, wird Ihre IP-Adresse von Google jedoch innerhalb von
      Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen
      Wirtschaftsraum zuvor gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den
      USA übertragen und dort gekürzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen
      benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um
      weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegenüber dem Websitebetreiber
      zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen
      Daten von Google zusammengeführt. Sie können die Speicherung der Cookies durch eine entsprechende Einstellung
      Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht
      sämtliche Funktionen dieser Website vollumfänglich werden nutzen können. Sie können darüber hinaus die Erfassung
      der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google
      sowie die Verarbeitung dieser Daten durch Google verhindern, indem sie das unter dem folgenden Link
      (http://tools.google.com/dlpage/gaoptout?hl=de) verfügbare Browser-Plugin herunterladen und installieren.
    </p>
    
    <p>
      Nähere Informationen zu Nutzungsbedingungen und Datenschutz finden Sie unter
      http://www.google.com/analytics/terms/de.html bzw. unter
      https://support.google.com/analytics/answer/6004245?hl=de. Wir weisen Sie darauf hin, dass auf dieser Webseite
      Google Analytics um den Code „gat._anonymizeIp();“ erweitert wurde, um eine anonymisierte Erfassung von
      IP-Adressen (sog. IP-Masking) zu gewährleisten.
    </p>
    
    <h2>Auskunftsrecht</h2>
    <p>
      Sie haben jederzeit das Recht auf Auskunft über die bezüglich Ihrer Person gespeicherten Daten, deren Herkunft
      und Empfänger sowie den Zweck der Speicherung
    </p>
    
    <h2>Wer wir sind</h2>
    <p>Die Adresse unserer Website ist: https://www.mody.at.</p>
    
    <h2>Medien</h2>
    <p>
      Wenn du ein registrierter Benutzer bist und Fotos auf diese Website lädst, solltest du vermeiden, Fotos mit einem
      EXIF-GPS-Standort hochzuladen. Besucher dieser Website könnten Fotos, die auf dieser Website gespeichert sind,
      herunterladen und deren Standort-Informationen extrahieren.
    </p>
    
    <h2>Cookies</h2>
    <p>
      Cookies sind kleine Dateien, die es dieser Webseite ermöglichen auf dem Computer des Besuchers spezifische, auf
      den Nutzer bezogene Informationen zu speichern, während unsere Website besucht wird. Cookies helfen uns dabei, die
      Nutzungshäufigkeit und die Anzahl der Nutzer unserer Internetseiten zu ermitteln, sowie unsere Angebote für Sie
      komfortabel und effizient zu gestalten. Wir verwenden einerseits Session-Cookies, die ausschließlich für die Dauer
      Ihrer Nutzung unserer Website zwischengespeichert werden und zum anderen permanente Cookies, um Informationen über
      Besucher festzuhalten, die wiederholt auf unsere Website zugreifen. Der Zweck des Einsatzes dieser Cookies besteht
      darin, eine optimale Benutzerführung anbieten zu können sowie Besucher wiederzuerkennen und bei wiederholter
      Nutzung eine möglichst attraktive Website und interessante Inhalte präsentieren zu können. Der Inhalt eines
      permanenten Cookies beschränkt sich auf eine Identifikationsnummer. Name, IP-Adresse usw. werden nicht
      gespeichert. Eine Einzelprofilbildung über Ihr Nutzungsverhalten findet nicht statt. Eine Nutzung unserer Angebote
      ist auch ohne Cookies möglich. Sie können in Ihrem Browser das Speichern von Cookies deaktivieren, auf bestimmte
      Webseiten beschränken oder Ihren Webbrowser (Chrome, IE, Firefox,…) so einstellen, dass er sie benachrichtigt,
      sobald ein Cookie gesendet wird. Sie können Cookies auch jederzeit von der Festplatte ihres PC löschen. Bitte
      beachten Sie aber, dass Sie in diesem Fall mit einer eingeschränkten Darstellung der Seite und mit einer
      eingeschränkten Benutzerführung rechnen müssen.
    </p>
    
    <p>
      Falls du ein Konto hast und dich auf dieser Website anmeldest, werden wir ein temporäres Cookie setzen, um
      festzustellen, ob dein Browser Cookies akzeptiert. Dieses Cookie enthält keine personenbezogenen Daten und wird
      verworfen, wenn du deinen Browser schließt.
    </p>
    
    <p>
      Wenn du dich anmeldest, werden wir einige Cookies einrichten, um deine Anmeldeinformationen und Anzeigeoptionen
      zu speichern. Anmelde-Cookies verfallen nach zwei Tagen und Cookies für die Anzeigeoptionen nach einem Jahr. Falls
      du bei der Anmeldung „Angemeldet bleiben“ auswählst, wird deine Anmeldung zwei Wochen lang aufrechterhalten. Mit
      der Abmeldung aus deinem Konto werden die Anmelde-Cookies gelöscht.
    </p>
    
    <h2>Eingebettete Inhalte von anderen Websites</h2>
    <p>
      Beiträge auf dieser Website können eingebettete Inhalte beinhalten (z.&nbsp;B. Videos, Bilder, Beiträge etc.).
      Eingebettete Inhalte von anderen Websites verhalten sich exakt so, als ob der Besucher die andere Website besucht
      hätte.
    </p>
    
    <p>
      Diese Websites können Daten über dich sammeln, Cookies benutzen, zusätzliche Tracking-Dienste von Dritten
      einbetten und deine Interaktion mit diesem eingebetteten Inhalt aufzeichnen, inklusive deiner Interaktion mit dem
      eingebetteten Inhalt, falls du ein Konto hast und auf dieser Website angemeldet bist.
    </p>
    
    <h2>Mit wem wir deine Daten teilen</h2>
    <p>Mit niemandem ausser unserem eigenen Team und das auch nur, wenn nötig.</p>
    
    <h2>Wie lange wir deine Daten speichern</h2>
    <p>
      Für Benutzer, die sich auf unserer Website registrieren, speichern wir die persönlichen Informationen, die sie in
      ihren Benutzerprofilen angeben. Alle Benutzer können jederzeit ihre persönlichen Informationen einsehen, verändern
      oder löschen (der Benutzername kann nicht verändert werden). Administratoren der Website können diese
      Informationen ebenfalls einsehen und verändern.
    </p>
    
    
    <h2>Welche Rechte du an deinen Daten hast</h2>
    <p>
      Wenn du ein Konto auf dieser Website besitzt kannst du die Löschung aller personenbezogenen Daten, die wir von
      dir gespeichert haben, anfordern. Dies umfasst nicht die Daten, die wir aufgrund administrativer, rechtlicher oder
      sicherheitsrelevanter Notwendigkeiten aufbewahren müssen.
    </p>
    
    <h2>Wohin deine Daten gesendet werden</h2>
    <p>Die Daten werden über eine sicher Datenleitung nur an unseren eigenen Server gesendet und dort sicher verwahrt.</p>
    
    <h2>Was wir sammeln und speichern</h2>
    <p>Während du unsere Website besuchst, zeichnen wir auf:</p>
    
    <ul>
      <li>Angesehene Produkte: Hier zeigen wir dir Produkte, die du vor Kurzem angesehen hast.</li>
      <li>Standort, IP-Adresse und Browser-Typ: Wir verwenden dies für Zwecke wie die Schätzung von Steuern und
        Versandkosten
      </li>
      <li>Versandadresse: Wir werden dich auffordern, diese anzugeben, um beispielsweise die Versandkosten bestimmen zu
        können, bevor du eine Bestellung aufgibst, und dir die Bestellung zusenden zu können.
      </li>
    </ul>
    
    <p>Wir nutzen auch Cookies, um den Inhalt deines Warenkorbs zu verfolgen, während du unsere Website besuchst.</p>
    
    <p>
      Wenn du bei uns einkaufst, werden wir dich auffordern, Informationen wie deinen Namen, deine Rechnungs- und
      Versandadresse, deine E-Mail-Adresse und deine Telefonnummer, Kreditkartendaten/Zahlungsdetails sowie optionale
      Kontoinformationen wie Benutzername und Kennwort anzugeben. Wir nutzen diese Informationen für folgende
      Zwecke:
    </p>
    
    <ul>
      <li>Zusenden von Informationen über dein Konto und Bestellung</li>
      <li>Antwort auf deine Anfragen, inklusive Erstattungen und Beschwerden</li>
      <li>Bearbeitung von Zahlungsvorgängen und Verhinderung von Betrug</li>
      <li>Richten Sie Ihr Konto für unseren Shop ein</li>
      <li>Einhaltung aller rechtlichen Verpflichtungen, beispielsweise die Steuerberechnung</li>
      <li>Verbesserung unsere Shop-Angebote</li>
      <li>Senden von Marketing-Nachrichten, wenn du diese erhalten möchtest</li>
    </ul>
    
    <p>
      Wenn du ein Konto bei uns erstellst, speichern wir deinen Namen, deine Adresse, deine E-Mail-Adresse und deine
      Telefonnummer. Diese Angaben werden bei künftigen Bestellungen zum Ausfüllen der Bezahlinformationen
      verwendet.
    </p>
    
    <p>
      Wir speichern Informationen über dich üblicherweise so lange, wie wir sie für den Zweck der Erfassung und Nutzung
      benötigen und verpflichtet sind, sie zu speichern. Beispielsweise speichern wir Bestellinformationen für XXX&nbsp;Jahre
      aus Steuer- und Abrechnungsgründen. Dazu gehört dein Name, deine E-Mail-Adresse sowie deine Rechnungs- und
      Versandadresse.
    </p>
    
    <p>Wir speichern auch Kommentare oder Bewertungen, wenn du dich dazu entscheidest diese zu hinterlassen.</p>
    
    
    <h2>Meta Pixel (ehemals Facebook Pixel)</h2>
    <p>
      Unsere Website nutzt zur Konversionsmessung das Besucheraktions-Pixel von Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublin 2, Irland.
      
      Wenn Sie auf eine von Meta geschaltete Anzeige klicken oder unsere Website besuchen, wird über dieses Pixel eine Verbindung zu den Meta-Servern hergestellt. Dabei kann Meta nachvollziehen, dass Sie unsere Seite besucht haben. So können wir die Wirksamkeit von Meta-Werbung auswerten und zukünftige Kampagnen optimieren.
      
      Die erhobenen Daten sind für uns anonym, d. h. wir können keine Rückschlüsse auf die Identität einzelner Nutzer ziehen. Die Daten werden jedoch von Meta gespeichert und verarbeitet, sodass eine Verbindung zum jeweiligen Nutzerprofil möglich ist. Dies ermöglicht Meta, Ihnen personalisierte Werbung auf Meta-Plattformen und außerhalb anzuzeigen (sog. Retargeting).
      
      Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
      
      Weitere Informationen finden Sie in der Datenschutzerklärung von Meta:
      [https://www.facebook.com/privacy/policy](https://www.facebook.com/privacy/policy)
    </p>



    <h2>Hotjar</h2>
    <p>
      Wir nutzen auf unserer Website <strong>Hotjar</strong>, einen Webanalysedienst der Hotjar Ltd., Dragonara Business Centre, 5th Floor, Dragonara Road, Paceville St Julian’s STJ 3141, Malta.
    </p>
    <p>
      Hotjar hilft uns zu verstehen, wie Besucher unsere Website nutzen (z. B. Mausbewegungen, Klicks und Scrollverhalten). Damit können wir unsere Website und das Nutzererlebnis gezielt verbessern.
    </p>
    <p>
      Die erhobenen Informationen sind anonymisiert. IP-Adressen werden nur gekürzt gespeichert. Hotjar speichert keine personenbezogenen Daten. Weitere Informationen finden Sie unter:
      <a href="https://www.hotjar.com/privacy/" target="_blank" rel="noopener noreferrer">https://www.hotjar.com/privacy/</a>
    </p>
    <p>
      <strong>Rechtsgrundlage:</strong> Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
    </p>
    <p>
      <strong>Widerruf:</strong> Sie können Ihre Einwilligung jederzeit über unser Cookie-Banner widerrufen.
    </p>



    <h2>Wer aus unserem Team hat Zugang</h2>
    <p>Mitglieder unseres Teams haben Zugang zu den Informationen, die du uns zur Verfügung stellst. Zum Beispiel können
      sowohl Administratoren als auch Shop-Manager auf Folgendes zugreifen:</p>
      
      <ul>
        <li>Bestellinformationen wie gekaufte Produkte, der Zeitpunkt des Kaufs sowie die Versandadresse und</li>
        <li>Kundeninformationen wie dein Name, E-Mail-Adresse, sowie Rechnungs- und Versandinformationen.</li>
      </ul>
      
      <p>
        Unsere Teammitglieder haben Zugriff auf diese Informationen, um Bestellungen zu bearbeiten, Rückerstattungen
        vorzunehmen und Dich zu unterstützen.
      </p>
  </PublicLegalContent>
</template>
